'use client';

import { useEffect } from 'react';
import { useSnackbar } from '../contexts/SnackbarContext';
import { setGlobalSnackbar } from '../utils/snackbar';

export const SnackbarInitializer = () => {
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    setGlobalSnackbar(showSnackbar);
  }, [showSnackbar]);

  return null;
};